import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
         Welcome to Bandit Tuning!
       <br></br>
        
        Thank you you for choosing us for your vehicle tuning needs.
        <br></br>
          Please fill out the form below to get started.
        </p>

      </header>
    </div>
  );
}

export default App;
